<div
  #assetItem
  class="container"
  *ngIf="vm"
  (dragenter)="onDragEnter($event)"
  (dragleave)="onDragLeave($event)"
>
  <div
    class="empty flex"
    *ngIf="vm.type === 0"
    [ngClass]="{ 'drag-over': isDragOver }"
  >
    <span>+</span>
  </div>
  <div class="full flex column" *ngIf="vm.type > 0">
    <div
      class="header flex row"
      [ngClass]="{
        'media-background': vm.type === 1,
        'gfx-background': vm.type === 2,
        'layout-background': vm.type === 3,
        'block-background': vm.type === 4,
        'live-feed-background': vm.type === 5,
        'stack-background': vm.type === 6,
      }"
    >
      <span class="shortcut-label">{{ vm.shortcutLabel }}</span>
      <div class="divider"></div>
      <!-- <div class="label">{{ vm.shortcutLabel }}</div> -->
      <div
        class="asset-name"
        title="{{ vm.assetName }}"
        *ngIf="vm.type > 0"
        [draggable]="true"
        (dragstart)="onDragStart($event)"
        (dragend)="onDragEnd($event)"
      >
        {{ vm.assetName }}
      </div>
      <div class="asset-name" title="{{ vm.assetName }}" *ngIf="vm.type === 0">
        {{ vm.assetName }}
      </div>
      <div class="headset-icon cursor-pointer"></div>
      <div class="divider"></div>
      <div
        class="x-icon cursor-pointer"
        (click)="broadcastPresetViewModel.onAssetItemDelete(vm)"
      >
        ✖
      </div>
    </div>
    <div class="middle flex row">
      <ng-container *ngIf="vm.isStack || vm.isBlock">
        <div class="show-list">
          <div
            class="loading-container"
            *ngIf="!this.playlistItems || this.playlistItems.length === 0"
          >
            <div class="loading-spinner"></div>
            <div class="loading-text">
              Loading {{ vm.isBlock ? "Block" : "Stack" }} Items
            </div>
          </div>
          <div
            #playlistContainer
            class="show-list__container"
            *ngIf="this.playlistItems && this.playlistItems.length > -1"
          >
            <ng-container *ngFor="let show of playlistItems; let index = index">
            <div
              class="show-list__group-header"
              *ngIf="vm.isStack && isGroupHead(index)"
              [style.--group-color]="getGroupColor(index)"
              [title]="getGroupLabel(index)"
            >
              {{ getGroupLabel(index) || '&nbsp;' }}
            </div>
            <div
              class="show-list__item"
              [class.in-group]="vm.isStack && isInGroup(index)"
              [class.group-end]="vm.isStack && isGroupEnd(index)"
              [style.--group-color]="vm.isStack ? getGroupColor(index) : null"
              [ngClass]="{
                active: show.isCurrent,
                'selection-range':
                  vm.isStack &&
                  !show.isCurrent &&
                  isInSelectionRange(index) &&
                  !isSelectionEnd(index),
                'selection-end':
                  vm.isStack && !show.isCurrent && isSelectionEnd(index),
              }"
              (mouseenter)="vm.isStack && onRowHover(index, $event)"
              (mouseleave)="vm.isStack && onRowLeave(index, $event)"
            >
              <div
                class="show-list__play-indicator-container"
                *ngIf="vm.isStack"
                [class.stack-editing-disabled]="isStackEditingDisabled"
                (mouseenter)="
                  vm.isStack && onPlayIndicatorHover(index);
                  $event.stopPropagation()
                "
                (mouseleave)="
                  vm.isStack && onPlayIndicatorLeave(); $event.stopPropagation()
                "
                (click)="
                  vm.isStack && onPlayIndicatorClick(index);
                  $event.stopPropagation()
                "
              >
                <svg
                  class="show-list__play-indicator"
                  width="22"
                  height="23"
                  viewBox="0 0 22 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    *ngIf="vm.isStack && show.isCurrent"
                    d="M7.40039 16.2199C7.40039 16.6392 7.88536 16.8723 8.21274 16.6104L14.1123 11.8907C14.3625 11.6905 14.3626 11.31 14.1123 11.1098L8.21274 6.39011C7.88536 6.12821 7.40039 6.36129 7.40039 6.78055V16.2199Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div
                *ngIf="vm.isStack && isSelectionEnd(index)"
                class="selection-line-short"
              ></div>
              <div
                *ngIf="vm.isStack && isSelectionEnd(index)"
                class="selection-end-circle"
                [ngClass]="{ 'animate-circle': isAnimating(index) }"
              ></div>
              <div
                *ngIf="
                  vm.isStack &&
                  isInSelectionRange(index, 1) &&
                  !isSelectionEnd(index)
                "
                class="selection-line"
              ></div>
              <div class="show-list__name-container" [title]="show.name">
                <div class="show-list__name">{{ show.name }}</div>
              </div>
              <div class="show-list__duration-container">
                <div class="show-list__duration">
                  {{ formatDurationToSeconds(show.duration) }}
                </div>
              </div>
              <div class="show-list__visibility-control" *ngIf="vm.isStack">
                <evrideo-visibility-icon
                  [isVisible]="vm.testAssetItemVisibility(show.id)"
                  (onVisibilityChange)="onVisibilityChange(show.id)"
                ></evrideo-visibility-icon>
              </div>
              <div class="show-list__context-menu-container" *ngIf="vm.isStack">
                <div
                  class="show-list__three-dots"
                  *ngIf="
                    hoveredRowIndex === index &&
                    !show.isCurrent &&
                    !isStackEditingDisabled
                  "
                  (click)="onThreeDotsClick(index, $event)"
                >
                  <svg
                    width="5"
                    height="15"
                    viewBox="0 0 5 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.5 10.75C3.125 10.75 3.6875 11.0938 4 11.625C4.3125 12.1875 4.3125 12.8438 4 13.375C3.6875 13.9375 3.125 14.25 2.5 14.25C1.84375 14.25 1.28125 13.9375 0.96875 13.375C0.65625 12.8438 0.65625 12.1875 0.96875 11.625C1.28125 11.0938 1.84375 10.75 2.5 10.75ZM2.5 5.75C3.125 5.75 3.6875 6.09375 4 6.625C4.3125 7.1875 4.3125 7.84375 4 8.375C3.6875 8.9375 3.125 9.25 2.5 9.25C1.84375 9.25 1.28125 8.9375 0.96875 8.375C0.65625 7.84375 0.65625 7.1875 0.96875 6.625C1.28125 6.09375 1.84375 5.75 2.5 5.75ZM4.25 2.5C4.25 3.15625 3.90625 3.71875 3.375 4.03125C2.8125 4.34375 2.15625 4.34375 1.625 4.03125C1.0625 3.71875 0.75 3.15625 0.75 2.5C0.75 1.875 1.0625 1.3125 1.625 1C2.15625 0.6875 2.8125 0.6875 3.375 1C3.90625 1.3125 4.25 1.875 4.25 2.5Z"
                      fill="black"
                      fill-opacity="0.6"
                    />
                  </svg>
                </div>
              </div>
            </div>
            </ng-container>
          </div>
        </div>

        <!-- Context Menu -->
        <div
          class="context-menu"
          *ngIf="showContextMenu"
          [style.left.px]="contextMenuPosition.x"
          [style.top.px]="contextMenuPosition.y"
        >
          <div class="context-menu__item" (click)="onMovePlayheadClick()">
            Move Playhead
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!vm.isBlock && !vm.isStack">
        <div class="stats-container" [innerHTML]="vm.itemStats()"></div>
        <img
          src="{{ vm.previewUrl }}"
          (error)="vm.onPreviewError($event)"
          [alt]="vm.assetName"
          class="preview-asset"
        />
      </ng-container>

      <div class="flex column circles">
        <div class="flex row justify-end" *ngIf="vm.isProgram">
          <div class="circle red"></div>
        </div>
        <div class="flex row justify-end" *ngIf="vm.isPreview">
          <div class="circle green"></div>
        </div>
      </div>
    </div>
    <div class="footer flex row">
      <div
        class="preview-button cursor-pointer"
        (click)="
          vm.isProccesing === false &&
            broadcastPresetViewModel.onPreviewClicked($event, vm)
        "
      >
        PREVIEW
      </div>
      <div class="divider"></div>
      <div
        class="program-button cursor-pointer"
        (click)="
          vm.isProccesing === false &&
            broadcastPresetViewModel.onProgramClicked($event, vm)
        "
      >
        PROGRAM
      </div>
      <div class="divider"></div>
      <!-- <div
        class="volume-button cursor-pointer"
        (click)="vm.toggleVolumeClicked()"
      > -->
      <!--<span *ngIf="vm.volumeEnabled">🔊</span>
        <span *ngIf="!vm.volumeEnabled">🔇</span>-->

      <!-- <evrideo-volume-icon
          [disabled]="!vm.volumeEnabled"
        ></evrideo-volume-icon> -->
      <!-- </div> -->
      <!-- <div class="divider"></div> -->
      <!-- <div class="full-screen-button cursor-pointer"> -->
      <!--⛶-->
      <!-- <evrideo-full-screen-icon></evrideo-full-screen-icon> -->
      <!-- </div> -->
      <!-- <div class="divider"></div> -->
      <!-- <div class="settings-button cursor-pointer"> -->
      <!--⚙-->
      <evrideo-gear-icon
        (click)="openBlockManager()"
        *ngIf="vm.isStack || vm.isBlock"
      ></evrideo-gear-icon>
    </div>
    <evrideo-tot-sliding-toggle
      [hidden]="true"
      [default]="'this'"
      [this]="'for'"
      [that]="'css'"
    >
    </evrideo-tot-sliding-toggle>
  </div>

  <div class="span-controls span-controls--right" *ngIf="vm.type > 0">
    <button
      class="span-btn span-btn--plus"
      *ngIf="showRightPlus"
      (click)="onExpandRight($event)"
      title="Expand right"
    >+</button>
    <button
      class="span-btn span-btn--minus"
      *ngIf="showRightMinus"
      (click)="onShrinkRight($event)"
      title="Shrink right"
    >−</button>
  </div>

  <div class="span-controls span-controls--bottom" *ngIf="vm.type > 0">
    <button
      class="span-btn span-btn--plus"
      *ngIf="showBottomPlus"
      (click)="onExpandDown($event)"
      title="Expand down"
    >+</button>
    <button
      class="span-btn span-btn--minus"
      *ngIf="showBottomMinus"
      (click)="onShrinkDown($event)"
      title="Shrink down"
    >−</button>
  </div>
</div>
